module.exports = __webpack_public_path__ + "media/images/pic/meeting-b57b0346f4bc62de93d6f4809b117e0a.jpeg";